export default __webpack_public_path__ + "static/media/back-icon.34b7b21e.svg";